import { render, staticRenderFns } from "./servicesProduct2.vue?vue&type=template&id=f4f982a0&scoped=true"
import script from "./servicesProduct2.vue?vue&type=script&lang=js"
export * from "./servicesProduct2.vue?vue&type=script&lang=js"
import style0 from "./servicesProduct2.vue?vue&type=style&index=0&id=f4f982a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f982a0",
  null
  
)

export default component.exports